import { Heading, Text, useColorMode, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { MdSort, MdOutlineTitle } from "react-icons/md";
import AddTaskComponent from "./AddTaskComponent";
import TaskComponent from "./TaskComponent";
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { BsFillFlagFill, BsChatLeftDots } from "react-icons/bs";
import { BiTime, BiShareAlt } from "react-icons/bi";
import { FiMoreHorizontal } from "react-icons/fi";
import { AiOutlineEdit, AiOutlineDelete, AiOutlineStar } from "react-icons/ai";
import CommentsModal from "./CommentsModal";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import EditProjectModal from "./EditProjectModal";
import { useSelector, useDispatch } from "react-redux";
import {
  addToFavProject,
  deleteProject,
  removeFromFavProject,
} from "../actions/project";
import { useNavigate } from "react-router-dom";
import {
  getProjectTasks,
  projectTaskFilterTime,
  projectTaskFilterTitle,
} from "../actions/projecttask";
import {
  RedditShareButton,
  RedditIcon,
  FacebookIcon,
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import { getFavProjects } from "../actions/favproject";
import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

type Props = {
  isOpen?: boolean;
  loading?: boolean;
};

const ProjectTask = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const project = useSelector((data: any) => data?.singleproject);
  const userboi = useSelector((data: any) => data?.user?.authData);
  const projecttasks = useSelector(
    (data: any) => data?.projecttask?.projectTaskData
  );
  const { colorMode } = useColorMode();
  const {
    isOpen: commentIsOpen,
    onOpen: commentOnOpen,
    onClose: commentOnClose,
  } = useDisclosure();
  const {
    isOpen: deleteIsOpen,
    onOpen: deleteOnOpen,
    onClose: deleteOnClose,
  } = useDisclosure();
  const {
    isOpen: editIsOpen,
    onOpen: editOnOpen,
    onClose: editOnClose,
  } = useDisclosure();
  const token = JSON.parse(localStorage?.getItem("token") as string);
  const cancelRef = React.useRef(null);
  const deleteProjectBoi = () => {
    dispatch(deleteProject(token, project?._id, navigate));
    deleteOnClose();
    navigate("/app/today");
  };
  const SHARE_URL = "https://taskem.netlify.app/project/" + project?._id;
  const copyClipboard = () => {
    navigator.clipboard.writeText(SHARE_URL);
    toast.success("Copied to clipboard", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };
  const addToFavourite = () => {
    dispatch(addToFavProject(token, project?._id, navigate));
  };
  const removeFromFavourite = () => {
    dispatch(removeFromFavProject(token, project?._id, navigate));
  };
  const handleDrag = () => {
    console.log("Hell yea");
  };
  return (
    <div
      className={
        !props.isOpen
          ? "pl-[10%] w-full min-h-[calc(100vh-80px)] h-full p-11 mr-9"
          : "pl-[30%] w-full min-h-[calc(100vh-80px)] h-full p-11 mr-9"
      }
    >
      <div className="flex sticky items-center w-full justify-between">
        <div className="flex items-center gap-2 flex-wrap">
          {props?.loading ? (
            <Skeleton height="25px" width="120px" />
          ) : (
            <Heading as="h2" fontSize="2xl">
              {
                project?.name?.length >= 20 ? project?.name?.slice(0,19) + "......" : project?.name
              }            </Heading>
          )}
          {props?.loading ? (
            <Skeleton height="16px" width="400px" />
          ) : (
            <Text fontSize="md" color="gray.500">
              {
                project?.description?.length >= 30 ? project?.description?.slice(0,29) + "......" : project?.description
              }
            </Text>
          )}
        </div>
        {colorMode === "light" ? (
          <div className="flex items-center gap-3">
            <div
              className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f0f0f0] rounded-md"
              onClick={() => {
                commentOnOpen();
              }}
            >
              <BsChatLeftDots size="25" />
              <Text color="gray.500" fontSize="md" className = "md:flex hidden">
                Comments
              </Text>
            </div>
            <Menu>
              <MenuButton className="flex items-center gap-2 cursor-pointer hover:bg-[#f0f0f0] rounded-md">
                <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f0f0f0] rounded-md">
                  <BiShareAlt size="25" />
                  <Text color="gray.500" fontSize="md" className = "md:flex hidden"> 
                    Share
                  </Text>
                </div>
              </MenuButton>
              <MenuList>
                <MenuItem gap="0.5rem" onClick={copyClipboard}>
                  <MdContentCopy
                    size="1.5rem"
                    style={{
                      marginLeft: "0.1rem",
                    }}
                  />
                  Copy to clipboard
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <RedditShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <RedditIcon size={32} round />
                  </RedditShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Reddit
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <FacebookShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Facebook
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <WhatsappShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <WhatsappIcon size={32} round />
                  </WhatsappShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Whatsapp
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <TwitterShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Twitter
                  </Text>
                </MenuItem>
              </MenuList>
            </Menu>
            {project?.userId === userboi?._id ? (
              <Menu>
                <MenuButton
                  _hover={{
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f0f0f0] rounded-md">
                    <MdSort size="25" />
                    <Text color="gray.500" fontSize="md" className = "md:flex hidden">
                      View
                    </Text>
                  </div>
                </MenuButton>
                <MenuList>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(getProjectTasks(token, project?._id));
                    }}
                  >
                    <MdSort size="25" />
                    <Text fontSize="md">Custom</Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(projectTaskFilterTime(token, project?._id));
                    }}
                  >
                    <BiTime size="25" />
                    <Text fontSize="md">By Time</Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(projectTaskFilterTitle(token, project?._id));
                    }}
                  >
                    <MdOutlineTitle size="25" />
                    <Text fontSize="md">By Title</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            ) : (
              ""
            )}
            {project?.userId === userboi?._id ? (
              <Menu>
                <MenuButton
                  _hover={{
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f0f0f0] rounded-md">
                    <FiMoreHorizontal size="25" />
                  </div>
                </MenuButton>
                <MenuList>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      editOnOpen();
                    }}
                  >
                    <AiOutlineEdit size="20" color="#9bdaf3" />
                    <Text fontSize="md" color="#9bdaf3">
                      Edit Project
                    </Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      deleteOnOpen();
                    }}
                  >
                    <AiOutlineDelete size="20" color="#df3333" />
                    <Text fontSize="md" color="#df3333">
                      Delete Project
                    </Text>
                  </MenuItem>
                  {project?.isFav === true ? (
                    <MenuItem
                      className="flex items-center gap-3"
                      onClick={() => {
                        removeFromFavourite();
                      }}
                    >
                      <AiOutlineStar size="20" color="#f49c18" />
                      <Text fontSize="md" color="#f49c18">
                        Remove From Favourites
                      </Text>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      className="flex items-center gap-3"
                      onClick={() => {
                        addToFavourite();
                      }}
                    >
                      <AiOutlineStar size="20" color="#f49c18" />
                      <Text fontSize="md" color="#f49c18">
                        Add To Favourites
                      </Text>
                    </MenuItem>
                  )}
                </MenuList>
              </Menu>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <div
              className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#21242a] rounded-md"
              onClick={() => {
                commentOnOpen();
              }}
            >
              <BsChatLeftDots size="25" />
              <Text color="gray.500" fontSize="md" className = "md:flex hidden">
                Comments
              </Text>
            </div>
            <Menu>
              <MenuButton className="flex items-center gap-2 cursor-pointer hover:bg-[#21242a] rounded-md">
                <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#21242a] rounded-md">
                  <BiShareAlt size="25" />
                  <Text color="gray.500" fontSize="md" className = "md:flex hidden">
                    Share
                  </Text>
                </div>
              </MenuButton>
              <MenuList>
                <MenuItem gap="0.5rem" onClick={copyClipboard}>
                  <MdContentCopy
                    size="1.5rem"
                    style={{
                      marginLeft: "0.1rem",
                    }}
                  />
                  Copy to clipboard
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <RedditShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <RedditIcon size={32} round />
                  </RedditShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Reddit
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <FacebookShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Facebook
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <WhatsappShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <WhatsappIcon size={32} round />
                  </WhatsappShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Whatsapp
                  </Text>
                </MenuItem>
                <MenuItem gap="0.5rem">
                  <TwitterShareButton
                    url={SHARE_URL}
                    style={{
                      width: "100%",
                    }}
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <Text position="absolute" marginLeft={"10"}>
                    Twitter
                  </Text>
                </MenuItem>
              </MenuList>
            </Menu>
            {project?.userId === userboi?._id ? (
              <Menu>
                <MenuButton
                  _hover={{
                    backgroundColor: "#21242a",
                  }}
                >
                  <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#21242a] rounded-md">
                    <MdSort size="25" />
                    <Text color="gray.500" fontSize="md" className = "md:flex hidden">
                      View
                    </Text>
                  </div>
                </MenuButton>
                <MenuList>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(getProjectTasks(token, project?._id));
                    }}
                  >
                    <MdSort size="25" />
                    <Text fontSize="md">Custom</Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(projectTaskFilterTime(token, project?._id));
                    }}
                  >
                    <BiTime size="25" />
                    <Text fontSize="md">By Time</Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      dispatch(projectTaskFilterTitle(token, project?._id));
                    }}
                  >
                    <MdOutlineTitle size="25" />
                    <Text fontSize="md">By Title</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            ) : (
              ""
            )}
            {project?.userId === userboi?._id ? (
              <Menu>
                <MenuButton
                  _hover={{
                    backgroundColor: "#21242a",
                  }}
                >
                  <div className="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#21242a] rounded-md">
                    <FiMoreHorizontal size="25" />
                  </div>
                </MenuButton>
                <MenuList>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      editOnOpen();
                    }}
                  >
                    <AiOutlineEdit size="20" color="#9bdaf3" />
                    <Text fontSize="md" color="#9bdaf3">
                      Edit Project
                    </Text>
                  </MenuItem>
                  <MenuItem
                    className="flex items-center gap-3"
                    onClick={() => {
                      deleteOnOpen();
                    }}
                  >
                    <AiOutlineDelete size="20" color="#df3333" />
                    <Text fontSize="md" color="#df3333">
                      Delete Project
                    </Text>
                  </MenuItem>
                  {project?.isFav === true ? (
                    <MenuItem
                      className="flex items-center gap-3"
                      onClick={() => {
                        removeFromFavourite();
                      }}
                    >
                      <AiOutlineStar size="20" color="#f49c18" />
                      <Text fontSize="md" color="#f49c18">
                        Remove From Favourites
                      </Text>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      className="flex items-center gap-3"
                      onClick={() => {
                        addToFavourite();
                      }}
                    >
                      <AiOutlineStar size="20" color="#f49c18" />
                      <Text fontSize="md" color="#f49c18">
                        Add To Favourites
                      </Text>
                    </MenuItem>
                  )}
                </MenuList>
              </Menu>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
      <div className="flex flex-col w-full items-start mt-5 gap-4">
        <DragDropContext onDragEnd={handleDrag}>
          <Droppable droppableId="tasks">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="w-full flex flex-col gap-4"
              >
                {projecttasks?.map((task: any, index: any) => (
                  <Draggable key={index} draggableId={task?._id} index={index}>
                    {(provided) => (
                      <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        className="w-full"
                      >
                        <TaskComponent
                          title={task?.title}
                          description={task?.description}
                          id={task?._id}
                          isProjectTask={true}
                          projectId={task?.projectId}
                          candoAction={
                            project?.userId === userboi?._id ? true : false
                          }
                        />{" "}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {project?.userId === userboi?._id ? (
          <AddTaskComponent isProjectTask={true} projectId={project?._id} />
        ) : (
          ""
        )}
        {project?.userId === userboi?._id ? 
        projecttasks?.length === 0 ? (
          <div className=" flex w-full justify-center items-center">
            <div className="flex-col flex w-full items-center justify-center gap-3">
              <img src="/svgexport-27.svg" />
              <Heading fontSize="2xl">
                Be productive, Start creating tasks
              </Heading>
            </div>
          </div>
        ) : (
          ""
        ) : projecttasks?.length === 0 ? (
          <div className=" flex w-full justify-center items-center">
            <div className="flex-col flex w-full items-center justify-center gap-3">
              <img src="/svgexport-27.svg" />
              <Heading fontSize="2xl">
                Oops seems like this project has no tasks :(
              </Heading>
            </div>
          </div>
        ): ""}
      </div>
      <CommentsModal
        isOpen={commentIsOpen}
        onClose={commentOnClose}
        data={project}
      />
      {/* dleete project modal stuff */}
      <AlertDialog
        isOpen={deleteIsOpen}
        leastDestructiveRef={cancelRef}
        onClose={deleteOnClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Project
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={deleteOnClose} ref={cancelRef}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={deleteProjectBoi} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <EditProjectModal
        isOpen={editIsOpen}
        isFav={false}
        onClose={editOnClose}
        name={project?.name}
        description={project?.description}
        color={project?.color}
        id={project?._id}
      />
    </div>
  );
};

export default ProjectTask;
